import React from "react";
import {SvgIcon, SvgIconProps} from "@material-ui/core";

export function DoubleTickIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props} viewBox="0 0 17 10">
            <path
                d="M 7.551 9.855 L 5.043 4.913 C 4.886 4.622 5.199 4.477 5.356 4.622 L 8.021 7.093 L 16.644 0.04 C 16.8 -0.106 17.114 0.185 16.957 0.33 L 7.865 10 C 7.708 10 7.551 10 7.551 9.855 Z"
            />
            <path
                d="M 2.338 9.855 L 0.039 4.913 C -0.104 4.622 0.183 4.477 0.327 4.622 L 2.77 7.093 L 10.673 0.04 C 10.817 -0.106 11.104 0.185 10.961 0.33 L 2.626 10 C 2.482 10 2.338 10 2.338 9.855 Z"
            />
        </SvgIcon>
    )
}
